var map = {
	"./icon_8.png": "xKys",
	"./icon_RetaledLiterature.png": "G2kR",
	"./icon_calender.png": "LZ97",
	"./icon_doc.png": "pax4",
	"./icon_label_calendar.png": "a7n1",
	"./icon_label_person.png": "l16s",
	"./icon_label_trial.png": "UiII",
	"./icon_language.png": "mGrL",
	"./icon_overall_arrow.png": "vf9k",
	"./icon_overall_article.png": "3KJv",
	"./icon_overall_case.png": "czH+",
	"./icon_overall_research.png": "pUCd",
	"./icon_pubType.png": "POwD",
	"./icon_recommend_active.png": "PTXx",
	"./icon_similartrial.png": "LieB",
	"./icon_trial.png": "czO1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yUaa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/icon_.*\.png$
// module id = yUaa
// module chunks = 1